import { trpc } from '@tencent/tpro_appid_platform_appid_platform_service';
import { WithTypeCast } from '@raft/utils';

export type IGetAllAppIDsReq = WithTypeCast<trpc.appid_platform.appid_platform_service.IGetAllAppIDsReq>;

export type IGetAllAppIDsResp = WithTypeCast<trpc.appid_platform.appid_platform_service.IGetAllAppIDsResp>;

export const  { SystemID } = trpc.appid_platform.appid_platform_service;
